<template>
  <OLink pure class="rounded-md overflow-hidden flex bg-white sm:flex-row flex-col" :href="articleUrl" draggable="false">
    <OImage
      :src="imageUrl"
      alt="görsel"
      class="w-full sm:h-auto object-cover yazio-article-image flex-shrink-0"
      :class="{ slider: author }"
      loading="lazy"
      draggable="false"
    />
    <div class="p-4 flex flex-col" :class="{ 'sm:p-8 sm:justify-center': author }">
      <h3 class="text-lg font-bold line-clamp-2 sm:line-clamp-none text-primary-100" :class="{ 'sm:text-24 sm:leading-32': author }">
        {{ title }}
      </h3>
      <div v-if="author" class="mt-2">
        <div v-if="item.description" class="hidden sm:block sm:line-clamp-2 text-base text-primary-200">
          {{ item.description }}
        </div>
        <div class="flex items-center mt-3.75">
          <YazioAuthorImage :item="author" width="30" height="30" class="rounded-full mr-2" />
          <div class="mr-2 font-bold text-sm">{{ author.name }}</div>
          <div v-if="author.category" class="yazio-article-category px-2 rounded text-sm text-primary-300 leading-22">
            {{ author.category }}
          </div>
        </div>
      </div>
      <div v-else>
        <div v-if="item.description" class="text-sm line-clamp-2 mt-2 text-primary-200">{{ item.description }}</div>
        <div class="mt-2 text-primary-300 font-medium text-xs">{{ getDateWithTime(item.dates.updated) }}</div>
      </div>
    </div>
  </OLink>
</template>
<script>
import { defineComponent } from '@nuxtjs/composition-api';
import YazioAuthorImage from './YazioAuthorImage';
import { getImageUrl } from '~/modules/common/utils/imageUtils';
import { getDateWithTime } from '~/modules/common/utils/dateUtils';
import { getArticleUrl } from '~/modules/common/utils/routingUtils';
import { OLink, OImage } from '~/modules/common/components/ui';

export default defineComponent({
  components: { YazioAuthorImage, OLink, OImage },
  props: {
    item: {
      type: Object,
      required: true,
    },
    author: {
      type: Object,
    },
  },
  setup(props) {
    const titleSplit = props.item.title.split('Yazio:');
    const title = titleSplit[titleSplit.length - 1].trimStart();
    const imageUrl = getImageUrl(props.item?.image, { width: props.author ? 560 : 350 });
    const articleUrl = getArticleUrl({ article: props.item });
    return { title, imageUrl, articleUrl, getDateWithTime };
  },
});
</script>

<style lang="scss" scoped>
.yazio-article-category {
  border: 1px solid #e2e5ed;
}

.yazio-article-image {
  height: 170px;
}

@media (min-width: 640px) {
  .yazio-article-image {
    width: 175px;
    height: auto;

    &.slider {
      width: 497px;
    }
  }
}
</style>
